import { LOGIN_SUCCESS, loginSuccess, logout, LOGOUT } from "./authActions";
import { z } from "zod";

export const UserStateSchema = z.object({
  id: z.string(),
  token: z.string(),
  userType: z.enum(["Admin", "User"]),
});
export type UserState = z.infer<typeof UserStateSchema>;

export type State = {
  isLoggedIn: boolean;
  currentUser: UserState | null;
};

const initialState: State = {
  isLoggedIn: false,
  currentUser: null,
};

type Actions = ReturnType<typeof loginSuccess> | ReturnType<typeof logout>;

const authReducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      const loginAction = action as ReturnType<typeof loginSuccess>;
      return {
        ...state,
        isLoggedIn: true,
        currentUser: loginAction.payload,
      };
    }
    case LOGOUT:
      return {
        ...state,
        currentUser: null,
        isLoggedIn: false,
      };
    default:
      return state;
  }
};

export default authReducer;
